import React, { HTMLProps } from 'react';
import cn from 'classnames';
import { LockFilled } from '@ant-design/icons';

import { Text } from '~/components/Typo/Typo';
import { FontWeight, TextVariants } from '~/theme/constants';

import './LegacyWrapper.scss';

interface LegacyWrapperProps extends HTMLProps<HTMLDivElement> {
  label: string;
}

const LegacyWrapper: React.FC<LegacyWrapperProps> = ({ label, className, ...restParams }) => (
  <div {...restParams} className={cn(className, 'legacy')}>
    <LockFilled className="icon" />
    <Text className="label" size="xs" variant={TextVariants.SECONDARY} weight={FontWeight.MEDIUM}>
      {label}
    </Text>
  </div>
);

export default LegacyWrapper;
